import { createFileRoute } from "@tanstack/react-router";
import { requireUnitAdmin } from "@/utils/route-guards";

/**
 * The unit's admin only (ADR 0025 decision 4): everything on this page is the
 * business unit's own, and the rules refuse a house's admin every write here.
 * The rail already hides the entry for them; this is the boundary behind it,
 * for the address typed or followed from elsewhere.
 */
export const Route = createFileRoute("/bu-admin/analytics")({
  beforeLoad: ({ context }) => {
    requireUnitAdmin(context);
  },
});
